module.exports = __webpack_public_path__ + "static/teriyakiHero-b05fa3b18355451e2c54db4ed45e7acc.png";